import React from "react";

// moneda (opcional): para USD/BRL el punto es decimal ("22.50") y la coma también
// ("22,50"); sin moneda o en PYG el punto es separador de miles ("1.250.000").
export const parseMoneyInput = (value, moneda) => {
  if (value === null || value === undefined || value === "") return NaN;
  if (typeof value === "number") return value;
  if (moneda && moneda !== "PYG") {
    let t = String(value).trim().replace(/\s/g, "");
    if (t.includes(",")) t = t.replace(/\./g, "").replace(",", ".");
    else if ((t.match(/\./g) || []).length > 1) t = t.replace(/\./g, "");
    return parseFloat(t);
  }
  const normalized = String(value)
    .trim()
    .replace(/\s/g, "")
    .replace(/\./g, "")
    .replace(",", ".");
  return parseFloat(normalized);
};

export const normalizeMoneyValue = (value, moneda = "PYG") => {
  if (value === null || value === undefined) return "";
  const raw = String(value);
  if ((moneda || "PYG") === "PYG") {
    return raw.replace(/\D/g, "").replace(/^0+(?=\d)/, "");
  }
  let t = raw.replace(/[^\d.,]/g, "");
  // "1.250,50" (formato es-PY) → "1250.50"; "22,50" → "22.50"; "22.50" queda igual.
  if (t.includes(",")) t = t.replace(/\./g, "").replace(/,/g, ".");
  const i = t.indexOf(".");
  if (i !== -1) t = t.slice(0, i + 1) + t.slice(i + 1).replace(/\./g, "");
  return t;
};

export const formatMoneyInput = (value, moneda = "PYG") => {
  if (value === null || value === undefined || value === "") return "";
  if ((moneda || "PYG") !== "PYG") return String(value);
  const n = parseMoneyInput(value);
  if (Number.isNaN(n)) return "";
  return Math.round(n).toLocaleString("es-PY");
};

export default function MoneyInput({
  value,
  onChange,
  moneda = "PYG",
  className = "",
  readOnly = false,
  disabled = false,
  onBlur,
  onFocus,
  ...props
}) {
  const isPyg = (moneda || "PYG") === "PYG";

  return (
    <input
      {...props}
      type="text"
      inputMode={isPyg ? "numeric" : "decimal"}
      value={isPyg ? formatMoneyInput(value, moneda) : (value ?? "")}
      readOnly={readOnly}
      disabled={disabled}
      onChange={(e) => onChange?.(normalizeMoneyValue(e.target.value, moneda), e)}
      onBlur={onBlur}
      onFocus={onFocus}
      className={className}
    />
  );
}
